module.exports = __webpack_public_path__ + "img/paste_icon.2e051b3d.png";